module.exports = __webpack_public_path__ + "img/20201028.82aac11a.png";